import { ISystem } from 'common/services/directory_service/types';

export const SET_LOGGED_IN = 'SET_LOGGED_IN';

export type SetIsLoggedInActionType = {
    type: typeof SET_LOGGED_IN;
    isLoggedIn?: boolean;
    system?: ISystem;
};
